import { useThree } from '@react-three/fiber'
import { FunctionComponent, useEffect } from 'react'

interface ThreeJSObserveProps {}

const ThreeJSObserve: FunctionComponent<ThreeJSObserveProps> = () => {
  const state = useThree()

  useEffect(() => {
    /*eslint-disable */
    // @ts-ignore
    if (typeof __THREE_DEVTOOLS__ !== 'undefined') {
      console.warn(`__THREE_DEVTOOLS__ is valid, dispatching observe event`)
      console.log(state.scene)
      console.log(state.gl)
      // @ts-ignore
      __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', { detail: state.scene }))
      // @ts-ignore
      __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', { detail: state.gl }))
    }
    /* eslint-enable */
  }, [])

  return null
}

export default ThreeJSObserve
